import(/* webpackMode: "eager" */ "/vercel/path0/src/components/optimization/GoogleTagManager.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/style/globals.scss")